import groupBy from 'lodash-es/groupBy'
import mapValues from 'lodash-es/mapValues'

import { EMPTY_LIST, EMPTY_STRING } from '../../../../constants/common'
import { FILE_SCOPE_REQUEST } from '../../../../constants/file'
import {
  EMAIL_CREATION_FORM_TEMPLATE_MASS_API_PARAMS,
  EMAIL_CREATION_FORM_TEMPLATE_REQUEST_THREAD_API_PARAMS,
  EMAIL_RECIPIENTS_BUILDING_FIELD_NAME,
  EMAIL_RECIPIENTS_FLAT_FIELD_NAME,
  getEmailFormTemplateEntityApiParams,
  toEmailRecipientSelectItem,
} from '../../../Email'
import { getRequestTitle } from '../../../Request'

import { CREATE_EMAIL_POPUP_MODE_ATTACHED_REQUESTS } from './RequestProfileTabEmailsCreateEmailPopUp.constants'

function isAttachedRequestRecipientItem(item) {
  return Number.isFinite(item?.userId) && Number.isFinite(item?.requestId)
}

function getBuildingPrefill(building) {
  if (!building?.id) {
    return EMPTY_LIST
  }

  return [{ label: building.address?.value, value: building.id }]
}

function getFlatPrefill(flat, building) {
  if (!flat?.id) {
    return EMPTY_LIST
  }

  return [
    {
      building: building?.id != null ? { id: building.id } : undefined,
      label: flat.number ? `${flat.number}` : String(flat.id),
      number: flat.number,
      value: flat.id,
    },
  ]
}

export function isRequestProfileCreateEmailModeAttachedRequests(mode) {
  return mode === CREATE_EMAIL_POPUP_MODE_ATTACHED_REQUESTS
}

export function getAttachedRequestRecipientTagName(item) {
  const email = item.email ? ` <${item.email}>` : EMPTY_STRING
  const fullname = item.fullname || EMPTY_STRING

  return `${item.requestTitle || EMPTY_STRING} | ${fullname}${email}`
}

export function getStandardFilterModalInitialValues(requestData) {
  return {
    [EMAIL_RECIPIENTS_BUILDING_FIELD_NAME]: getBuildingPrefill(
      requestData?.building
    ),
    [EMAIL_RECIPIENTS_FLAT_FIELD_NAME]: getFlatPrefill(
      requestData?.flat,
      requestData?.building
    ),
  }
}

export function toAttachedRequestRecipientSelectItem(item) {
  const base = toEmailRecipientSelectItem(item)

  const requestId = item.request?.id
  const userId = item.id

  const value = requestId != null ? `${userId}_${requestId}` : base.value

  return {
    ...base,
    isArchivedRequest: !!item.request?.archived,
    optionId: value,
    requestId,
    requestTitle: getRequestTitle({
      requestNumber: item.request?.request_no,
      title: item.request?.title,
    }),
    userId,
    value,
  }
}

export function buildRecipientsByRequest(toItems) {
  const valid = toItems.filter(isAttachedRequestRecipientItem)

  return mapValues(groupBy(valid, 'requestId'), group =>
    group.map(item => item.userId)
  )
}

export function getRequestProfileCreateEmailPayload({
  audience,
  owner,
  payload,
}) {
  const { files = EMPTY_LIST, title, ...rest } = payload

  return {
    ...rest,
    audience,
    files,
    owner,
    subject: title,
  }
}

export function getRequestAttachItemsApiParams({
  objectId,
  ordering,
  page,
  parent,
}) {
  return {
    object_id: objectId,
    ordering,
    page,
    parent,
    scope: FILE_SCOPE_REQUEST,
  }
}

export function getRequestEmailAttachProps({ requestData, requestId }) {
  const directoryId = requestData?.directory_id

  return Number.isFinite(directoryId)
    ? {
        requestFolderModalProps: {
          directoryId,
          entityId: requestId,
          getApiProps: getRequestAttachItemsApiParams,
        },
      }
    : null
}

export function getRequestTemplateListApiParams({
  buildingId,
  isAttachedRequestsMode,
}) {
  const base = isAttachedRequestsMode
    ? EMAIL_CREATION_FORM_TEMPLATE_MASS_API_PARAMS
    : EMAIL_CREATION_FORM_TEMPLATE_REQUEST_THREAD_API_PARAMS

  return Number.isFinite(buildingId)
    ? { ...base, for_building: buildingId }
    : base
}

export function getRequestTemplateEntityApiParams({
  flatId,
  isAttachedRequestsMode,
  requestId,
}) {
  if (isAttachedRequestsMode) {
    return null
  }

  return getEmailFormTemplateEntityApiParams({
    flatId,
    requestId: Number(requestId),
  })
}

export function getRequestPreviewDependencyValues({
  isAttachedRequestsMode,
  recipient,
  requestId,
}) {
  const id = isAttachedRequestsMode ? recipient?.requestId : Number(requestId)

  return Number.isFinite(id) ? { request_id: id } : null
}
